import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Button } from 'antd';
import showElementByAuth from '~helpers/auth';
import { PlusOutlined } from '@ant-design/icons';
import { platformEntity, entityAction } from '~constants';
import NoPropertiesImg from '~images/no-properties.png';

const NoProperties = props => (
  <div className="no-properties">
    <div className="no-properties__container">
      <h3 className="no-properties__title">
        {props.t('cms:cms.no_properties.title.welcome_to_landlord')}
      </h3>
      <h3 className="no-properties__sub-title">
        {props.t('cms:cms.no_properties.title.create_one')}
      </h3>
      <div className="no-properties__summary-container">
        <img className="no-properties__image" src={NoPropertiesImg} alt="1" />
        <Row type="flex" justify="space-between" className="no-properties__step-container">
          <Col span={4} className="no-properties__step">
            {props.t('cms:cms.no_properties.summary.step_1')}
          </Col>
          <Col span={4} className="no-properties__step">
            {props.t('cms:cms.no_properties.summary.step_2')}
          </Col>
          <Col span={4} className="no-properties__step">
            {props.t('cms:cms.no_properties.summary.step_3')}
          </Col>
          <Col span={4} className="no-properties__step">
            {props.t('cms:cms.no_properties.summary.step_4')}
          </Col>
        </Row>
        <If
          condition={showElementByAuth(platformEntity.PROPERTIES_PROPERTIES, entityAction.CREATE)}
        >
          <div className="table-header__button-container" style={{ marginTop: 24, float: 'none' }}>
            <Button onClick={props.addBtn}>
              <PlusOutlined className="table-list__icon-plus" />
              {props.t('cms:cms.properties.create.name')}
            </Button>
          </div>
        </If>
      </div>
    </div>
  </div>
);

NoProperties.propTypes = {
  t: PropTypes.func.isRequired,
  addBtn: PropTypes.func.isRequired,
};

NoProperties.defaultProps = {
  t: () => {},
};

export default NoProperties;
